'use strict';

exports.druidQueryValidator = druidQueryValidator;

function druidQueryValidator(context, config, next) {
  var isValid = false;
  // queryObjectList = context.queryObjectList
  // context.queryObjectList = queryObjectList;
  next();
}